var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-input-box"
  }, [_c('div', {
    staticClass: "form-input-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.text,
      expression: "text"
    }],
    class: ['form-input', _vm.validator && !_vm.isDisabled ? 'form-input-validate' : ''],
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "change": _vm.onInputChanged,
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value;
      }
    }
  }), _vm.validator && !_vm.isDisabled ? _c('div', {
    staticClass: "validator-line"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.请填写必填项")) + " ")]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }